// extracted by mini-css-extract-plugin
module.exports = {"compressedVideo":"compressedVideo-module--compressed-video--11mOi","controls":"compressedVideo-module--controls--xKwFG"};